import { createQueryKeys } from '@lukemorales/query-key-factory';
import { EQueryKeys } from 'common/enums/query-kyes.enum';
import {
  getAuditObjectsHistoryService,
  getAuditObjectsIdService,
  getAuditObjectsService,
} from '../services/audit.service';
import {
  TAuditObjectsHistoryParams, TAuditObjectsHistoryRes,
  TAuditObjectsIdParams, TAuditObjectsIdRes,
  TAuditObjectsParams, TAuditObjectsRes,
} from '../types/audit.types';

export const auditQueryKeys = createQueryKeys(EQueryKeys.AuditQueryKeys, {
  getAuditObjects: (params?: TAuditObjectsParams) => ({
    queryKey: ['get-audit-objects', params],
    queryFn: (): Promise<TAuditObjectsRes> => getAuditObjectsService(params),
  }),
  getAuditObjectsHistory: (params?: TAuditObjectsHistoryParams) => ({
    queryKey: ['get-audit-objects-history', params],
    queryFn: (): Promise<TAuditObjectsHistoryRes> => getAuditObjectsHistoryService(params),
  }),
  getAuditObjectsId: (params?: TAuditObjectsIdParams) => ({
    queryKey: ['get-audit-objects-id', params],
    queryFn: (): Promise<TAuditObjectsIdRes> => getAuditObjectsIdService(params),
  }),
});
